import { SHOW_WIDGET,HIDE_WIDGET, SHOW_PAGE_TOOLS, HIDE_PAGE_TOOLS, LOADED_PAGE_TOOLS, SET_STRINGS, PRE_SAVE_TRANSLATION, SAVE_TRANSLATION, SEARCH,  UPDATE, RESET, SHOW_PAGE_TAGS,SHOW_ALL_TAGS, NEXT_PAGE, PREVIOUS_PAGE, TOGGLE_UNTRANSLATED } from './actionTypes'

export function reset() {
  return { 
    type : RESET
  }
}


export function showWidget() {

  OTUReact.renderView('AppTranslateWidget',{},document.getElementById('translateWidget'), function (ref) {
    console.log('Translate - Widget Shown');
  }); 

  return { 
    type : SHOW_WIDGET
  }

}

export function hideWidget() {

  return { type : HIDE_WIDGET } 

}

export function hidePageTools() {

    return { type : HIDE_PAGE_TOOLS } 

}

export function showPageTools() {

  return (dispatch, getState) => {

    const state = getState()

    if (!state.translate.pageToolsLoaded) {
      otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=translate.showPageTools',{
        "attr" : { 
          "data-keep-animation" : true 
        },
        callback : () => {
          dispatch( { type : LOADED_PAGE_TOOLS } )
        }
      });
    }

    dispatch({ type : SHOW_PAGE_TOOLS }); 

  }
}


export function update() {

  return (dispatch, getState) => {

    const state = getState()

    if ( state.translate.show==='page') {
      const tags = $("trans").map(function(){return $(this).attr("data-jconstant");}).get()

      dispatch ( { 
        type : UPDATE,
        tags  
      } )

      dispatch( getTranslations() )
    }



  }

}

export function getTranslations() {

  return (dispatch, getState) => {

    const state = getState()
    
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=translate.getTranslations',{
        tags : state.translate.tags
      }, {
        responseType : 'json',
        callback : ( result ) => {
        dispatch( { type : SET_STRINGS, strings : result.strings } )
      }
    });
  }

}

export function getAllTranslations() {

  return (dispatch, getState) => {

    const state = getState()
    
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=translate.getTranslations',{
        all : true
      }, {
        responseType : 'json',
        callback : ( result ) => {

        const tags = result.tags

        dispatch ( { 
          type : UPDATE,
          tags  
        } )

        dispatch( { type : SET_STRINGS, strings : result.strings } )
      }
    });
  }

}

export function preSaveTranslation( options = {}) {
  return {
    type : PRE_SAVE_TRANSLATION,
    string : options.string,
    language : options.language,
    value: options.value
  }
}

export function search( options = {}) {
  return {
    type : SEARCH,
    query : options.query
  }
}

export function setLanguage( options ={} ) {
  
  const languageTag = options.languageTag

  return (dispatch, getState) => {
    delete otuApp.appState.language;
    delete otuApp.appState.languageTag;
    switch (languageTag) {
      case 'en-GB':
        otuApp.appState.languageSef='en'
        break;
      case 'es-ES':
        otuApp.appState.languageSef='es'
        break;
    }
    
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=translate.setLanguage',{
        languageTag
      }, {
        responseType : 'json',
        callback : ( result ) => {
          console.log(result)
          window.location.assign( otuApp.appState.rootUrl );
        }
    });

  }
}

export function saveTranslation( options) {

  return (dispatch, getState) => {
    
    const state = getState()

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=translate.saveTranslation',{
        string : options.string,
        language : options.language,
        value : options.value
      }, {
        responseType : 'json',
        callback : ( result ) => {
          console.log(result);
          if ( result.success ) {


            if ( state.translate.show==='all') {
              dispatch( getAllTranslations() )
            }

            if ( state.translate.show==='page') {

              dispatch( update() )

              $('trans[data-jconstant="' + options.string +'"]').replaceWith( result.parsedString )
            }
          } else {
            alert( result.message );
          }
        }
    });

  }

}

export function showAllTags() {
  return (dispatch, getState) => {
    
    dispatch( {
      type : SHOW_ALL_TAGS
    } )

    dispatch( getAllTranslations( ) ) 
  }
}

export function showAllPageTags() {
  return (dispatch, getState) => {
    
    dispatch( {
      type : SHOW_PAGE_TAGS
    } )

    dispatch( update() )

    dispatch( getTranslations() )
  }
}

export function nextPage() {
  return {
    type : NEXT_PAGE
  }
}

export function previousPage() {
  return {
    type : PREVIOUS_PAGE
  }
}

export function toggleUntranslated() {
  return {
    type : TOGGLE_UNTRANSLATED
  }
}